import useDeleteApi from './useDeleteApi';
import { url } from '../../utils/confserveur';
export const useDeleteQuestion = () => {
  const { deleteData, isLoadingDeleteQuestion, errorDeleteQuestion } = useDeleteApi();

  const deleteQuestion = async (evalId) => {
    const urldelete = `${url}questions/${evalId}/`;
    await deleteData(urldelete);
  };

  return { deleteQuestion, isLoadingDeleteQuestion, errorDeleteQuestion };
};